import { useQuery } from '@tanstack/react-query';
import { getSocialPostGame } from '@/src/actions/social-posts';

export function useGameBySlug(gameSlug: string, enabled: boolean) {
  return useQuery({
    queryKey: ['socialGame', gameSlug],
    enabled: enabled && !!gameSlug,
    queryFn: async () => {
      const { data } = await getSocialPostGame(gameSlug);
      return data;
    },
    staleTime: 60_000,
  });
}
